var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loaded
    ? _c(
        "v-app",
        {
          staticStyle: { "max-width": "100vw", overflow: "hidden" },
          attrs: { id: "inspire" }
        },
        [
          _c("side-menu"),
          _vm._v(" "),
          _c("title-updater"),
          _vm._v(" "),
          _c("top-menu"),
          _vm._v(" "),
          _c("v-main", [_c("router-view")], 1),
          _vm._v(" "),
          _c("filter-menu")
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }